(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-collection"] && !Shopify.designMode) return;
  try {
    
  class RecipeFilter extends HTMLElement {
    connectedCallback() {
      this.filters = Array.from(this.querySelectorAll('.rc__filter'));
      this.cards = Array.from(this.querySelectorAll('.rc__card'));
      this.filters.forEach((btn) => btn.addEventListener('click', () => this.apply(btn)));
    }
    apply(btn) {
      const f = btn.dataset.filter;
      this.filters.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
      this.cards.forEach((card) => {
        card.hidden = !(f === 'all' || card.dataset.category === f);
      });
    }
  }
  if (!customElements.get('recipe-filter')) customElements.define('recipe-filter', RecipeFilter);

  } catch(e) { console.error(e); }
})();
})();
